export default __webpack_public_path__ + "static/media/442.755ca5bd.png";